import { AudienceDTO } from '../audience/audienceDTO';
import ResourceLinkDTO, { PublicationResultDTO } from '../resourceLinkDTO';
import { UserReadConfirmationDTO } from '../userReadConfirmationDTO';

export class Widget61DTO {
  link?: ResourceLinkDTO;

  userReadConfirmations?: UserReadConfirmationDTO[];

  audiences?: AudienceDTO[];

  publicationResults?: PublicationResultDTO[];
}
